'use strict';

export const SafeHTMLElement = typeof HTMLElement !== 'undefined' ? HTMLElement : Object;
